import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import ContentContainer from '../../components/ContentContainer';
import withUser from '../../hoc/withUser';
import { useStore } from '../../store';
import { sections, links, icons, contactInfo } from './constants';
import './styles.scss';
import SocialIcons from '../../components/SoicalIcons/SocialIcons';
import AdditionalLinks from '../../components/AdditionalLinks/AdditionalLinks';
import Cards from './components/Cards';
import CardsSupport from './components/CardsSupport';
import AvatarHeader from '../../components/AvatarHeader';
import '../../components/UserAvatar/styles.scss';
import { addQueryParamTimeToEscapeCash } from '../ProfilePage/helper/addQueryParamTimeToEscapeCash';

import { FELLER_ADMIN } from '../../utils/constants';

const WelcomePage = observer(({ user, authToken, i18n }) => {
  const {
    rootStore: { profileStore },
  } = useStore();
  const [name, setName] = useState('');

  const { t } = useTranslation('account');

  useEffect(() => {
    const getProfileData = async () => {
      try {
        if (!profileStore.profileData) {
          await profileStore.initProfile(user, authToken, i18n);
        }
        await profileStore.checkIsSuperAdmin();
        const { firstName, lastName } = profileStore.profileData;
        setName(`${firstName} ${lastName}`);
      } catch (err) {
        console.error(err);
      }
    };
    getProfileData();
  }, [user, authToken, i18n, profileStore]);

  if (!profileStore.profileData) {
    return null;
  }

  const roles = {
    [FELLER_ADMIN]: profileStore.isSuperAdmin,
  };
  const srcImage = profileStore?.profileData?.picture || user.picture;
  return (
    <ContentContainer fullWidth={true}>
      <AvatarHeader name={name} title={'profile.pageTitle'} subtitle={'welcome.subtitle'}>
        <div className="avatar-welcome-container">
          <img className="avatar-images" alt="Avatar" src={addQueryParamTimeToEscapeCash(srcImage)} />
        </div>
      </AvatarHeader>
      {sections.map((section, idx) => (
        <div className="welcome-section" key={idx}>
          <h2 className="welcome-section-title">{t(section.title)}</h2>
          <Cards section={section} roles={roles} />
        </div>
      ))}
      <div className="welcome-section">
        <h2 className="welcome-section-title align-left">{t('welcome.socialMedia')}</h2>
        <SocialIcons icons={icons} />
      </div>
      <div className="welcome-section">
        <h2 className="welcome-section-title align-left">{t('welcome.support')}</h2>
        <CardsSupport contactInfo={contactInfo} />
      </div>
      <div className="welcome-section">
        <h2 className="welcome-section-title align-left">{t('welcome.links')}</h2>
        <AdditionalLinks links={links} />
      </div>
    </ContentContainer>
  );
});
export default withUser(WelcomePage);
